import React, { useState, useEffect } from 'react'
import { decamelizeKeys } from 'humps'
import moment from 'moment-timezone'
import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { IEdiFile, IFilters } from 'apps/edi-tools/types'
import { Filters, filtersDefaults } from './Filters'
import { EdiFilesTable as Table } from './Table'

interface EdiFilesListResponse {
  ediFiles: {
    ediFile: IEdiFile
  }[]
  nextPage: boolean
}

export const FilesTable = () => {
  const [ediFiles, setEdiFiles] = useState<IEdiFile[]>([])
  const [filters, setFilters] = useState<IFilters>(filtersDefaults)
  const [page, setPage] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingError, setLoadingError] = useState(false)

  const fetchDataFromApi = async () => {
    setLoading(true)
    setLoadingError(false)

    const { createdBeforeDate, fileTypes, shipmentId, shipperId } = filters

    const filterString = JSON.stringify(
      decamelizeKeys({
        ...(shipperId ? { shipperApplicationId: shipperId } : {}),
        ...(shipmentId ? { shipmentId } : {}),
        ...(fileTypes.length ? { ediFileType: fileTypes.join(',') } : {}),
        ...(createdBeforeDate ? { createdBefore: moment(createdBeforeDate).unix() } : {}),
      })
    )

    const queryParams = {
      filters: filterString,
      page_count: page - 1,
    }

    try {
      const res: EdiFilesListResponse = await callApi({
        endpoint: ENDPOINTS.ediFiles,
        method: 'GET',
        params: queryParams,
      })
      setLoading(false)
      setEdiFiles(res.ediFiles.map(a => a.ediFile))
      setHasNextPage(res.nextPage)
    } catch (e) {
      setLoading(false)
      setLoadingError(true)
    }
  }

  const applyFilters = (updatedFilters: IFilters) => {
    setFilters({ ...filters, ...updatedFilters })
  }

  const onPageChange = (pageNumber: number) => {
    setPage(pageNumber)
  }

  useEffect(() => {
    fetchDataFromApi()
  }, [page, filters])

  // TODO: fix the layout
  return (
    <div className='flex justify-center'>
      <div className='flex flex-grow-1'>
        <div className='flex flex-column col-lg-2'>
          <Filters filters={filters} applyFilters={applyFilters} />
        </div>
        <Table
          ediFiles={ediFiles}
          currentPage={page}
          hasNextPage={hasNextPage}
          onPageChange={onPageChange}
          loading={loading}
          loadingError={loadingError}
        />
      </div>
    </div>
  )
}
